import { render, staticRenderFns } from "./PrintPosFaMedModular.vue?vue&type=template&id=a0170486&scoped=true"
import script from "./PrintPosFaMedModular.vue?vue&type=script&lang=js"
export * from "./PrintPosFaMedModular.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaMedModular.vue?vue&type=style&index=0&id=a0170486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0170486",
  null
  
)

export default component.exports